/**
 * Schémas Zod CRM — activités (E08-07).
 */
import { z } from 'zod';
import { CRM_ACTIVITY_DIRECTIONS, CRM_ACTIVITY_TYPES } from '../enums/crm.enum.js';
import { paginationQuerySchema, uuidSchema } from './common.schema.js';
const optionalText = (max) => z.string().trim().max(max).nullable().optional();
const isoDateTimeSchema = z.string().datetime().nullable().optional();
/** Durée d'une activité, en minutes (jusqu'à 24 h). */
const durationSchema = z.number().int().min(0).max(1440).nullable().optional();
const activityBaseSchema = {
    type: z.enum(CRM_ACTIVITY_TYPES),
    subject: z.string().trim().min(1).max(180),
    content: optionalText(5000),
    occurredAt: isoDateTimeSchema,
    direction: z.enum(CRM_ACTIVITY_DIRECTIONS).nullable().optional(),
    interlocutorName: optionalText(180),
    durationMinutes: durationSchema,
    prospectId: uuidSchema.nullable().optional(),
    clientId: uuidSchema.nullable().optional(),
    opportunityId: uuidSchema.nullable().optional(),
    ownerUserId: uuidSchema.nullable().optional(),
    /** Réservé aux traitements automatiques : ignoré et ramené à `false` côté serveur. */
    isAutomatic: z.boolean().optional(),
};
/** Paramètres de `GET /activities`. */
export const activityListQuerySchema = paginationQuerySchema.extend({
    filter: z
        .object({
        prospectId: uuidSchema.optional(),
        clientId: uuidSchema.optional(),
        opportunityId: uuidSchema.optional(),
        type: z.enum(CRM_ACTIVITY_TYPES).optional(),
        ownerUserId: uuidSchema.optional(),
        from: z.string().datetime().optional(),
        to: z.string().datetime().optional(),
    })
        .optional(),
});
/** Corps de `POST /activities`. */
export const activityCreateSchema = z.object(activityBaseSchema);
/** Corps de `PATCH /activities/:id`. */
export const activityUpdateSchema = z
    .object(activityBaseSchema)
    .partial()
    .refine((value) => Object.values(value).some((field) => field !== undefined), {
    message: 'Aucun champ à mettre à jour.',
});
//# sourceMappingURL=activity.schema.js.map